import { render, staticRenderFns } from "./EditRules.vue?vue&type=template&id=749a37a6&scoped=true"
import script from "./EditRules.vue?vue&type=script&lang=js"
export * from "./EditRules.vue?vue&type=script&lang=js"
import style0 from "./EditRules.vue?vue&type=style&index=0&id=749a37a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_6m5rqjauvbyej62p7eiecas4wq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749a37a6",
  null
  
)

export default component.exports